<template>
  <navbar
    :titleObj="titleObj"
    :title="title"
    :couponTitleVisible="false"
    :navbarLoginVisible="false"
    navbarLogoName="otoLogo.jpg"
    navbarLogoLink="/merchant/oto"
    :isOTOPage="true"
  />
</template>

<script>
import navbar from './navbar.vue'

export default {
  name: 'OTOtNavbar',
  props: {
    title: {
      type: String,
      default: ''
    },
    titleObj: {
      type: Object,
      default: null
    }
  },
  components: {
    navbar
  }
}
</script>
